<script setup lang="ts">
import { ref } from "vue";
import { FilterField, TableField } from "../../../../components/table/table";
import UnitOfMeasuresForm from "./UnitOfMeasuresForm.vue";
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import { Permission } from "../../../../types/auth";

withDefaults(
  defineProps<{
    showHeader?: boolean;
    showQuickTour?: boolean;
    showTitle?: boolean;
    showNextButton?: boolean;
  }>(),
  {
    showHeader: true,
    showQuickTour: true,
    showTitle: true,
  }
);

const endPoint = "/clients/inventory/item-management/unit-of-measures/";
const title = "Unit of Measures";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const permissions = ref<Permission[]>();
const handlePrmissions = (data: Permission[]) => {
  permissions.value = data;
};

const fields: TableField[] = [
  { name: "icon", caption: "Icon", sortable: true, fieldType: "text" },
  { name: "code", caption: "Code", sortable: true, fieldType: "text" },
  { name: "name", caption: "Name", sortable: true, fieldType: "text" },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    @permissions="handlePrmissions"
    :show-header="showHeader"
    :show-quick-tour="showQuickTour"
    :show-title="showTitle"
  >
    <template #form-view>
      <UnitOfMeasuresForm
        :permissions="permissions"
        v-if="showForm"
        :data="selectedData"
        :end-point="endPoint"
        :title="title"
        :mode="formMode"
        @save="refreshData = !refreshData"
        @close="showForm = !showForm"
      />
    </template>
  </ListTemplate>
</template>
